import { Button, Form } from 'react-bootstrap';
import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import { FUNDING_PARTNERS, FundingData } from '../types';
import { useUpdateTenantNotificationSettingsMutation } from '../hooks/useUpdateFunding';
import { useNewFundingPartners } from '../hooks/useNewFundingPartners';

export const FundingSearch = (props: {
  funding: FundingData;
  hideHeader?: boolean;
  onFind: (funding: FundingData) => void;
}) => {
  const { hideHeader, onFind } = props;
  const [maxDate] = useState(new Date());
  const { mutate: updateFunding } = useUpdateTenantNotificationSettingsMutation();
  const { setViewedFundingPartners } = useNewFundingPartners();
  const [funding, setFunding] = useState<FundingData>(props.funding);

  return (
    <div className="funding__search-container">
      <div className="funding__help-container">
        {!hideHeader && (
          <div className="growegy-font16--weight500 growegy-font-em">
            Find the right funding for you
          </div>
        )}
        <div>
          <div className="d-inline-block">
            <div className="numbered-list-index__container">1</div>
          </div>{' '}
          Share a few details about your business.
        </div>
        <div>
          <div className="d-inline-block">
            <div className="numbered-list-index__container">2</div>
          </div>{' '}
          Growegy will automatically match you with our lending partners.
        </div>
        <div>
          <div className="d-inline-block">
            <div className="numbered-list-index__container">3</div>
          </div>{' '}
          Choose one of the partners and proceed with the application process.
        </div>
      </div>
      <div className="funding__search-separator" />
      <div>
        <Form onSubmit={() => {}}>
          <Form.Group className="funding__search-row">
            <label className="funding__label">
              What is your current (estimated) personal credit score?
            </label>
            <input
              type="text"
              autoFocus={true}
              maxLength={3}
              placeholder="100..850"
              value={funding?.personalCreditScore ?? ''}
              onChange={(
                e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
              ) => {
                const value = e.target.value.replace(/[^0-9]/g, '');
                const personalCreditScore = value ? +value : null;
                const newFunding = { ...funding, personalCreditScore };
                setFunding(newFunding);
              }}
              className="funding__score-input"
            />
          </Form.Group>
          <Form.Group className="funding__search-row">
            <label className="funding__label">When was your company officially registered?</label>
            <div>
              <DatePicker
                showTimeSelect={false}
                dateFormat="MMMM yyyy"
                showMonthYearPicker={true}
                isClearable={true}
                minDate={new Date('1980-01-01')}
                maxDate={maxDate}
                selected={
                  funding.businessStartYear && funding.businessStartMonth
                    ? new Date(funding.businessStartYear!!, funding.businessStartMonth!! - 1, 15)
                    : null
                }
                onChange={(newValue) => {
                  const newFunding = newValue
                    ? {
                        ...funding,
                        businessStartYear: newValue.getFullYear(),
                        businessStartMonth: newValue.getMonth() + 1,
                      }
                    : {
                        ...funding,
                        businessStartYear: null,
                        businessStartMonth: null,
                      };
                  setFunding(newFunding);
                }}
                className="growegy-form__input"
              />
            </div>
          </Form.Group>
          <Form.Group className="funding__search-row">
            <label className="funding__label">What is the loan amount you are looking for?</label>
            <input
              type="text"
              maxLength={8}
              value={funding?.sumOfLoanCustomerNeeds ?? ''}
              onChange={(
                e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
              ) => {
                const value = e.target.value.replace(/[^0-9]/g, '');
                const sumOfLoanCustomerNeeds = value ? +value : null;
                const newFunding = { ...funding, sumOfLoanCustomerNeeds };
                setFunding(newFunding);
              }}
              className="funding__amount-input"
            />
          </Form.Group>
        </Form>
        <Button
          variant="primary"
          className="funding__action-button button-apply w-100"
          onClick={() => {
            updateFunding(funding);
            onFind(funding);
            setViewedFundingPartners(FUNDING_PARTNERS.map((x) => x.code));
          }}
        >
          Find Funding
        </Button>
      </div>
    </div>
  );
};
